import Table from "./table";
import { useMemo, useState} from "react";
import moment from 'moment';
import ManageUserDropdownMenu from "./dashboard/manage-user-dropdown-menu";
import { useLicencesDispatch, useLicencesState } from "../../context/LicenceContext";

const Licences = () => {
  const { licences, currentPage } = useLicencesState();
  const [currentTab, setCurrentTab] = useState("");
  const licencesDispatch = useLicencesDispatch();

  const columns = useMemo(() => [
    { header: "Email", accessor: "email" },
    { header: "Discord", accessor: "discord_user.tag" },
    { header: "Licence", accessor: "licence.key" },
    {
      header: "Expiry",
      id: "expiry",
      accessor: (row) => {
        if (row.licence) {
          return row?.licence?.expiry !== null ? moment(row.licence?.expiry).format("DD/MM/yyy HH:mm:ss") : "N/A";
        } else {
          return 'N/A';
        }
      }
    },
    { header: "Licence Status",  accessor: "licence.status.status" },
    {
      header: "Manage",
      id: "manage",
      Cell: ({cell}) => (
        <ManageUserDropdownMenu cell={cell}/>
      )
    }
  ]);

  const handlePreviousClick = async() => {
  }
  const handleNextClick = async() => {
  }
  const handleSearch = async(e) => {

  }

  const handleTabClick = async(tab) => {
  }

  return (
    <>
      <div id="dropdownDotsHorizontal" className="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600">
        <ul className="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownMenuIconHorizontalButton">
          <li>
            <a href="#" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Dashboard</a>
          </li>
          <li>
            <a href="#" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Settings</a>
          </li>
          <li>
            <a href="#" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Earnings</a>
          </li>
        </ul>
        <div className="py-2">
          <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white">Separated link</a>
        </div>
      </div>

      {/* Header Title */}
      <div className="px-5 md:px-10 py-7">
        <h1 className="text-black dark:text-white text-3xl font-semibold">
          Manage Licences
        </h1>
      </div>

      {/* Inner Navigation */}
      <nav className="px-5 md:px-10 border-b max-w-full overflow-auto flex space-x-5">
        <a
          onClick={() => handleTabClick('all')}
          className={
            currentTab === "" ?
              "pb-1.5 text-sm whitespace-nowrap transition duration-100 cursor-pointer text-black dark:text-white border-b-2 border-black dark:border-white"
              :
              "pb-1.5 text-sm whitespace-nowrap transition duration-100 cursor-pointer text-black dark:text-white !text-opacity-50 hover:!text-opacity-100"
          }>
          All Users
        </a>
        <a
          onClick={() => handleTabClick('active')}
          className={
            currentTab === "active" ?
              "pb-1.5 text-sm whitespace-nowrap transition duration-100 cursor-pointer text-black dark:text-white border-b-2 border-black dark:border-white"
              :
              "pb-1.5 text-sm whitespace-nowrap transition duration-100 cursor-pointer text-black dark:text-white !text-opacity-50 hover:!text-opacity-100"
          }>
          Active Users
        </a>
        <a
          onClick={() => handleTabClick('expired')}
          className={
            currentTab === "expired" ?
              "pb-1.5 text-sm whitespace-nowrap transition duration-100 cursor-pointer text-black dark:text-white border-b-2 border-black dark:border-white"
              :
              "pb-1.5 text-sm whitespace-nowrap transition duration-100 cursor-pointer text-black dark:text-white !text-opacity-50 hover:!text-opacity-100"
          }>
          Expired Users
        </a>
      </nav>

      {/* Page */}
      <div className="px-5 md:px-10 pt-5 pb-10">
        {/* Search Bar */}

        {/* Grid */}
        <div className="w-full">
          <div className="flex items-center justify-between text-sm mt-4 pb-3">
            <div className="flex-1 relative group max-w-4xl ">
              <input
                onChange={handleSearch}
                placeholder="Search by email, key, Discord user"
                className="pl-9 relative transition focus:!ring focus-within:z-20 bg-white bg-[#18181B] placeholder-gray-300 dark:placeholder-gray-500 text-gray-800 dark:text-white py-0 px-3 w-full disabled:cursor-not-allowed h-8 text-sm rounded-md input-group:rounded-none input-group:first:rounded-l-md input-group:last:rounded-r-md input-group:-ml-px input-group:first:!ml-0 !border-gray-200 dark:!border-gray-700 focus:!border-blue-300 dark:focus:!border-blue-400 !ring-blue-400 !ring-opacity-40">

              </input>
            </div>
            <div className="flex space-x-2 mr-4">
              <div>
                <button onClick={handlePreviousClick}
                        disabled={licences.page === 0}
                        className="dark:disabled:bg-red-500 disabled:cursor-not-allowed cursor-pointer px-3 h-8 text-sm rounded-md text-gray-800 dark:text-white bg-white dark:bg-gray-700 hover:bg-white dark:hover:bg-gray-600 border border-gray-300 dark:border-gray-600 after:via-gray-100 dark:after:via-gray-500 focus:outline-none shadow-sm hover:shadow focus:shadow active:shadow-none box-border relative after:absolute inline-flex items-center align-middle min-w-min select-none outline-none justify-center text-center whitespace-nowrap transition appearance-none focus:outline-none font-medium">
                  Previous
                </button>
              </div>
              <div>
                <button
                  onClick={handleNextClick}
                  disabled={!licences.hasMore}
                  className="dark:disabled:bg-red-500 disabled:cursor-not-allowed cursor-pointer px-3 h-8 text-sm rounded-md text-gray-800 dark:text-white bg-white dark:bg-gray-700 hover:bg-white dark:hover:bg-gray-600 border border-gray-300 dark:border-gray-600 after:via-gray-100 dark:after:via-gray-500 focus:outline-none shadow-sm hover:shadow focus:shadow active:shadow-none box-border relative after:absolute inline-flex items-center align-middle min-w-min select-none outline-none justify-center text-center whitespace-nowrap transition appearance-none focus:outline-none font-medium">
                  Next
                </button>
              </div>
            </div>
          </div>

          <Table columns={columns} data={licences.rows} />
        </div>
      </div>
    </>
  )
}


export default Licences;